import constants, { HTTP_METHODS } from '../../../settings/shared/constants'
import axiosClient from '../../common';

function saveVersion(fileData) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.api.app.createVersion + fileData.id + "?comment=" + fileData.comments,
    method: HTTP_METHODS.PUT,
    headers: headers,
    data: {}
  })
}

function ExtractFile(extractdata) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.extractFile,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: extractdata
  })
}

function CopyFile(copydata) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.copyFile,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: copydata
  })
}

function MoveFile(movedata) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.moveFile,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: movedata
  })
}

function CompressFile(compressdata) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.compressFile,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: compressdata
  })
}

function TrashFolder(trashdata) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.trashFolder,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: trashdata
  })
}

function DeleteFolder(deletedata) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.deleteFolder,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: deletedata
  })
}

function RestoreFile(restoredata) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.restoreFile,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: restoredata
  })
}

function RenameFile(renameData) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.renameFile,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: renameData
  })
}

function SaveVersion(filedata) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.SaveFileVersion,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: filedata
  })
}

function restoreVersionObjects(restoreData) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.restoreVersionObjects,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: restoreData,
  })
}

function PendingJobs(routeKey, jobStates, pageNumber, pageSize) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.getPendingJobs + '/' + routeKey + '?jobStates=' + jobStates +
      "&page=" + pageNumber + "&size=" + pageSize,
    method: HTTP_METHODS.GET,
    headers: headers,
    data: {}
  })
}

function ViewOriginalVersion(originaldata) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.ViewOriginalVersion,
    method: HTTP_METHODS.POST,
    headers: headers,
    data: originaldata
  })
}

function GetStorageJobId(storageJobId) {
  let jwtToken = localStorage.getItem('accessToken');
  let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
  return axiosClient({
    url: constants.fileapi.fileJobs.GetStorageJobId + storageJobId,
    method: HTTP_METHODS.GET,
    headers: headers,
    data: ''
  })
}

const FileJobsService = {
  saveVersion, ExtractFile, CopyFile, DeleteFolder, TrashFolder, MoveFile, CompressFile, RestoreFile, RenameFile, SaveVersion, restoreVersionObjects, PendingJobs, ViewOriginalVersion, GetStorageJobId
}

export default FileJobsService;